import {styled, Tooltip} from '@mui/material';
import { isDesktop } from '@shared/constants/media-queries';

export const TooltipStyled = styled(Tooltip)({
  '& .MuiTooltip-tooltip': {
    padding: props => props.padding,
  }
})